import axios from "axios";
import {
  ResponseItem,
  ResponseList,
  ResponseRemove,
} from "../../models/clientModels/interfaces/Response";
import {CurriculumListParams, EDCurriculum} from "../../models/serverModels/education/EDCurriculum";

import * as Params from "../../models/clientModels/interfaces/apiParams";

const education = axios.create({
  baseURL: "/API",
});

export const getList = async (params: CurriculumListParams): Promise<ResponseList<EDCurriculum>> =>
  education({
    url: "/CurriculumList",
    method: "get",
    params,
  }).then((res) => res.data);

export const getItem = async (params: Params.GetItem): Promise<ResponseItem<EDCurriculum>> =>
  education({
    url: `/Curriculum/${params.id}`,
    method: "get",
    params,
  }).then((res) => res.data);

export const create = async (
  params: Params.Create<EDCurriculum>
): Promise<ResponseItem<EDCurriculum>> =>
  education({
    url: "/Curriculum",
    method: "post",
    data: params,
  }).then((res) => res.data);

export const remove = async (params: Params.Remove): Promise<ResponseRemove> =>
  education({
    url: `/Curriculum/${params.id}`,
    method: "delete",
    data: params,
  }).then((res) => res.data);

export const update = async (
  params: Params.Update<EDCurriculum>
): Promise<ResponseItem<EDCurriculum>> =>
  education({
    url: `/Curriculum/${params.id}`,
    method: "put",
    data: params,
  }).then((res) => res.data);

export const getReport = async (params: Params.GetItem): Promise<ResponseItem<string>> =>
  education({
    url: `/CurriculumReport/${params.id}`,
    method: "get",
    params,
  }).then((res) => res.data);
